module.exports = {"152202001":"林海街道","152202002":"新城街道","152202003":"温泉街道","152202004":"伊尔施街道","152202100":"天池镇","152202101":"白狼镇","152202102":"五岔沟镇","152202103":"明水河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152202.json
// module id = 566
// module chunks = 0